import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { withRouter, Link } from "react-router-dom"
import { connect } from "react-redux"
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Label,
  Badge,
  Input,
  Table,
} from "reactstrap"
import Select from "react-select"
import { useSelector } from "react-redux"
import PropTypes from "prop-types"
import { ReactSearchAutocomplete } from "react-search-autocomplete"
import { isEmpty } from "lodash"
import moment from "moment"
import Modal from "react-bootstrap/Modal"
import ButtonSpinner from "../../components/ButtonSpinner"
// import Multiselect from "multiselect-react-dropdown"

//Import Styles
import "./styles.scss"
//Data Table packeages
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
  PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import { CSVExport } from "react-bootstrap-table2-toolkit"
//import filterFactory, { selectFilter } from 'react-bootstrap-table2-filter'

//components
import Breadcrumbs from "../../components/Common/Breadcrumb"
import * as myTeamScheduleAction from "../../store/bXlUZWFtU2NoZWR1bGU/actions"
import * as permissionAction from "../../store/cGVybWlzc2lvbg/actions"

const MyTeamSchedule = (props) => {
  const { SearchBar } = Search
  const title = "My Team Schedule"
  const { dispatch, searchBarStyle } = props

  useEffect(() => {
    dispatch(myTeamScheduleAction.loadRecordsMetaData())
    dispatch(permissionAction.loadEmployee())
    dispatch(
      myTeamScheduleAction.loadMyTeamScheduleList({
        isManageEC: true,
        eCStatus: "pending",
      })
    )
  }, [1])
  //const specificDispatch = useDispatch()
  const update = useSelector((specificstate) => specificstate)
  console.log(update, "update")

  const myTeamUpdate = useSelector((state) => state.myTeamSchedule)
  console.log(myTeamUpdate, "manageUpdateEc")

  const { recordsMetaData = {}, teamSchedule_details = [] } = myTeamUpdate

  const permissionUpdate = useSelector(
    (specificstate) => specificstate.permissionrequest
  )
  const { employee_list = [] } = permissionUpdate

  //Date format
  const sessionUpdate = useSelector((specificstate) => specificstate.session)

  const { user = [] } = sessionUpdate

  console.log(user, "user details from session")
  //Date format
  const dateSetting =
    !isEmpty(user) && user.setting && user.setting.dateFormate
      ? user.setting.dateFormate.toUpperCase()
      : []

  const dateFormate = !isEmpty(dateSetting) && dateSetting ? dateSetting : ""

  //manage Ec initial state
  const [myTeamData, setMyTeamData] = useState({
    company: [],
    branch: [],
    department: [],
    fromDate: "",
    toDate: "",
    leadNo: "",
  })

  //handle change

  const handleChange = async (e) => {
    setMyTeamData({ ...myTeamData, [e.target.name]: e.target.value })
  }

  //dropdown initial state
  const [companies, setCompanies] = useState([])
  const [branches, setBranches] = useState([])
  const [events, setEvents] = useState([])
  const [salesAgent, setSalesAgent] = useState([])
  // const [paymentStatus, setPaymentStatus] = useState([])

  //clearance modal state
  const [clearanceModal, setClearanceModal] = useState(false)
  //alter checkbox
  const alterList = [
    {
      label: "Is Alter",
      value: true,
    },
  ]

  const [isAlter, setIsAlter] = useState("")
  const handleAlterChange = async (e, value) => {
    let isChecked = e.target.checked
    if (isChecked) {
      setIsAlter(value)
    } else {
      setIsAlter(false)
    }
  }
  //reset filter form

  const resetForm = () => {
    setCompanies([])
    setBranches([])
    setEvents([])
    setSalesAgent([])
    // setEcAgent([])
    // setPaymentStatus([])
    setIsAlter(false)
    setMyTeamData({
      fromDate: "",
      toDate: "",
      leadNo: "",
    })
    dispatch(
      myTeamScheduleAction.loadMyTeamScheduleList({
        isManageEC: true,
        eCStatus: "pending",
      })
    )
  }

  //button spinner state
  const [btnLoader, setBtnLoader] = useState(false)

  //dropdown options

  const company =
    !isEmpty(companies) && companies.map((company) => company.value)
  const branch = !isEmpty(branches) && branches.map((branch) => branch.value)
  const branchOptions =
    !isEmpty(recordsMetaData) &&
    recordsMetaData.branchOptions.filter(
      (branch) =>
        branch.companyId ===
        companies.map((company) => company.value).toString()
    )

  //employee options(agent options)

  const employeeList =
    !isEmpty(employee_list) &&
    employee_list.map((employee) => {
      return {
        _id: employee._id,
        empCode: employee.empCode,
        name: employee.name,
        companyId: employee.companyId,
        roleId: employee.roleId,
      }
    })
  console.log(employee_list, "employeeee")
  const createOptions = (array) => {
    const options = []
    !isEmpty(array) &&
      array.forEach((element) => {
        const labelEmployee = element.empCode.concat(" - ", element.name)

        let obj = {}
        obj.value = element._id
        obj.label = labelEmployee
        obj.empCode = element.empCode
        obj.companyId = element.companyId
        obj.roleId = element.roleId
        options.push(obj)
      })
    return options
  }

  const ecagentOptions = createOptions(employeeList)
  //fuse options for venue(autocomplete field)
  const fuseOptions = {
    keys: ["empCode", "label"],
  }

  //apply filter submit

  const clientFilter = () => {
    var searchCompany = companies && companies ? company : ""
    var searchBranch = branches && branches ? branch : ""
    var searchEvent = events && events ? events.value : ""
    var searchAgent = salesAgent && salesAgent ? salesAgent.value : ""
    // var searchPaymentStatus =
    //   paymentStatus && paymentStatus ? paymentStatus.value : ""
    var searchFromDate =
      myTeamData && myTeamData.fromDate
        ? moment(myTeamData.fromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      myTeamData && myTeamData.toDate
        ? moment(myTeamData.toDate).format("YYYY-MM-DD")
        : ""
    var searchLeadNo = myTeamData && myTeamData.leadNo ? myTeamData.leadNo : ""
    var searchAlter = isAlter
    var searchvalue = {}
    searchvalue.isManageEC = true
    searchvalue.eCStatus = "pending"
    if (searchAlter) {
      searchvalue.isAlter = searchAlter
    }
    if (searchCompany) {
      searchvalue.companyId = searchCompany
    }
    if (searchBranch) {
      searchvalue.branchId = searchBranch
    }
    if (searchAgent) {
      searchvalue.employeeId = searchAgent
    }
    if (searchEvent) {
      searchvalue.eventId = searchEvent
    }
    if (searchLeadNo) {
      searchvalue.leadNo = searchLeadNo
    }

    if (searchFromDate) {
      searchvalue.eventFromDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.eventToDate = searchToDate
    }

    dispatch(myTeamScheduleAction.loadMyTeamScheduleList(searchvalue))
    setBtnLoader(true)
    setTimeout(() => {
      setBtnLoader(false)
    }, 2000)
  }
  //data table for manageEc

  let slNo = 0
  const myClientDataTable = !isEmpty(teamSchedule_details)
    ? teamSchedule_details.map((data, index) => {
      slNo = slNo + 1

      // const dateFormate =
      // !isEmpty(dateSetting) && dateSetting ? dateSetting : ""

      const leadDate = data.leadDate
        ? moment(data.leadDate)
          .subtract(5, "hours")
          .subtract(30, "minutes")
          .format(`${dateFormate} hh:mm A`)
        : []
      const colorCode =
        !isEmpty(recordsMetaData) &&
          recordsMetaData.processStatusOptions &&
          recordsMetaData.processStatusOptions.length > 0
          ? recordsMetaData.processStatusOptions.find(
            (_) => _.processStatusId === data.ecClearanceStatus
          ) &&
          recordsMetaData.processStatusOptions.find(
            (_) => _.processStatusId === data.ecClearanceStatus
          )
          : ""

      const leadStatusLabel =
        !isEmpty(recordsMetaData) &&
          recordsMetaData.processStatusOptions &&
          recordsMetaData.processStatusOptions.length > 0
          ? recordsMetaData.processStatusOptions.find(
            (_) => _.processStatusId === data.ecProcessStatus
          ) &&
          recordsMetaData.processStatusOptions.find(
            (_) => _.processStatusId === data.ecProcessStatus
          ).label
          : ""
      const eventCount =
        !isEmpty(data) && data.events.length > 0 ? data.events.length : 0
      return {
        _id: data._id,
        sNo: slNo,
        leadno: data.leadNo,
        isAlter: data.isAlter,
        // leadno: data.leadNo,
        branchId: data.branchId,
        colorCode: !isEmpty(colorCode) ? colorCode.colorCode : "",
        statusName: !isEmpty(colorCode) ? colorCode.label : "",
        branchName: data.branchName,
        leadServiceName: data.leadServiceName,
        leadSourceName: data.leadSourceName,
        eventDetails: data.events,
        leadType: data.leadType,
        salesUrge: data.salesUrge,
        clientName: !isEmpty(data.clientDetails)
          ? data.clientDetails.firstName + " " + data.clientDetails.lastName
          : "",
        brideName: data.brideName,
        groomName: data.groomName,
        clientCode: !isEmpty(data.clientDetails)
          ? data.clientDetails.clientNo
          : "",
        overallStatus: !isEmpty(data.overAllStatus)
          ? data.overAllStatus
          : "--",
        allowOrderData: data.isAllowOrder,
        clientDetails: data.clientDetails,
        allowOrder: data.isAllowOrder === true ? "YES" : "NO",
        companyId: data.companyId,
        companyName: data.companyName,
        event: data.events,
        events: eventCount,

        leadDate: leadDate,
        ecProcessStatus: data.ecProcessStatus,
        ecProcessStatusName: data.ecProcessStatusName,
        clearanceReport:
          data.ecProcessStatus !== "PS2" ? data.ecProcessStatusName : "--",
        leadStatus: !isEmpty(leadStatusLabel) ? leadStatusLabel : "",
        key: index,
        createdAt: data.createdAt,
        processStatus: data.processStatus,
        cpRemarks: !isEmpty(data.clientDetails) ?
        data.clientDetails.profileRemarks : "--",
      cpStatus: !isEmpty(data.clientDetails) ?
      data.clientDetails.profileStatus : "--",
      }
    })
    : []

  console.log(myClientDataTable, "myClientDataTable")
  //download feature in data table
  const { ExportCSVButton } = CSVExport
  // const rowStyle = (row) => {
  //   console.log(row, "row details")
  //   const style = {}
  //   if (row.isAlter== true) {
  //     style.backgroundColor = "#3abd856e"
  //     // style.color = "white"
  //   } else {
  //     style.backgroundColor = "#ffffff"
  //   }

  //   return style
  // }


  //columns for data table
  const columns = [
    {
      dataField: "sNo",
      text: "S.No",
      style: (cell, row) => {
        if (row.isAlter != true) {
          return {
            backgroundColor: "",
          }
        } else {

          return {
            backgroundColor: "#3abd856e",
          }
        }
      },
    },
    {
      dataField: "leadno",
      text: "Lead No",
      sort: true,
      formatter: (cellContent, row) => {
        return (
          <div className={row.processStatus != "PS9" ? "disabled-button" : ""}>
            <Link
              to={{
                pathname: `/client-details/${row._id}`,
                state: { row: row,leadClientId: row, mode: "EC", menuName: "TeamSchedule" },
              }}
            >
              {row.leadno}
            </Link>
          </div>
        )
      },
      style: (cell, row) => {
        if (row.isAlter != true) {
          return {
            backgroundColor: "",
            color: "#e40d8c",
            textTransform: "uppercase",
          }
        } else {
          return {
            backgroundColor: "#3abd856e",
            color: "#e40d8c",
            textTransform: "uppercase",
          }
        }
      },
      headerStyle: {
        minWidth: "145px",
      },
    },

    {
      dataField: "companyName",
      text: "Company Name",
      sort: true,
      style: (cell, row) => {
        if (row.isAlter != true) {
          return {
            backgroundColor: "",
          }
        } else {

          return {
            backgroundColor: "#3abd856e",
          }
        }
      },
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "branchName",
      text: "Branch Name",
      sort: true,
      style: (cell, row) => {
        if (row.isAlter != true) {
          return {
            backgroundColor: "",
            textTransform: "uppercase",
          }
        } else {

          return {
            backgroundColor: "#3abd856e",
            textTransform: "uppercase",
          }
        }
      },
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "leadServiceName",
      text: "Service",
      sort: true,
      style: (cell, row) => {
        if (row.isAlter != true) {
          return {
            backgroundColor: "",
          }
        } else {

          return {
            backgroundColor: "#3abd856e",
          }
        }
      },
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "leadSourceName",
      text: "Lead Source",
      sort: true,
      style: (cell, row) => {
        if (row.isAlter != true) {
          return {
            backgroundColor: "",
          }
        } else {

          return {
            backgroundColor: "#3abd856e",
          }
        }
      },
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "leadType",
      text: "Lead Type",
      sort: true,
      style: (cell, row) => {
        if (row.isAlter != true) {
          return {
            backgroundColor: "",
          }
        } else {

          return {
            backgroundColor: "#3abd856e",
          }
        }
      },
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "clientCode",
      text: "Client Code",
      sort: true,
      style: (cell, row) => {
        if (row.isAlter != true) {
          return {
            backgroundColor: "",
            color: "#e40d8c",
            textTransform: "uppercase",
          }
        } else {

          return {
            backgroundColor: "#3abd856e",
            color: "#e40d8c",
            textTransform: "uppercase",
          }
        }
      },
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "clientName",
      text: "Client Name",
      sort: true,
      style: (cell, row) => {
        if (row.isAlter != true) {
          return {
            backgroundColor: "",
          }
        } else {

          return {
            backgroundColor: "#3abd856e",
          }
        }
      },
      headerStyle: {
        minWidth: "155px",
      },
    },
    {
      dataField: "cpStatus",
      text: "CP Status",
      style: (cell, row) => {
        if (row.isAlter != true) {
          return {
            backgroundColor: "",
          }
        } else {

          return {
            backgroundColor: "#3abd856e",
          }
        }
      },
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "cpRemarks",
      text: "CP Remarks",
      style: (cell, row) => {
        if (row.isAlter != true) {
          return {
            backgroundColor: "",
          }
        } else {

          return {
            backgroundColor: "#3abd856e",
          }
        }
      },
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "brideName",
      text: "Bride Name ",
      sort: true,
      style: (cell, row) => {
        if (row.isAlter != true) {
          return {
            backgroundColor: "",
          }
        } else {

          return {
            backgroundColor: "#3abd856e",
          }
        }
      },
      // style: {
      //   textTransform: "uppercase",
      // },
      headerStyle: {
        minWidth: "155px",
      },
    },
    {
      dataField: "groomName",
      text: "Groom Name ",
      sort: true,
      style: (cell, row) => {
        if (row.isAlter != true) {
          return {
            backgroundColor: "",
          }
        } else {

          return {
            backgroundColor: "#3abd856e",
          }
        }
      },
      headerStyle: {
        minWidth: "155px",
      },
    },
    {
      dataField: "leadDate",
      text: "Lead Date",
      sort: true,
      style: (cell, row) => {
        if (row.isAlter != true) {
          return {
            backgroundColor: "",
          }
        } else {

          return {
            backgroundColor: "#3abd856e",
          }
        }
      },
      headerStyle: {
        minWidth: "165px",
      },
    },
    {
      dataField: "salesUrge",
      text: "Sales Urge",
      sort: true,
      style: (cell, row) => {
        if (row.isAlter != true) {
          return {
            backgroundColor: "",
          }
        } else {

          return {
            backgroundColor: "#3abd856e",
          }
        }
      },
      headerStyle: {
        minWidth: "165px",
      },
    },
    {
      dataField: "events",
      text: "No of Events",
      sort: true,
      style: (cell, row) => {
        if (row.isAlter != true) {
          return {
            backgroundColor: "",
          }
        } else {

          return {
            backgroundColor: "#3abd856e",
          }
        }
      },
      formatter: (cellContent, row) => {
        return (
          <div
            className="space-between"
          // onClick={() => setEventDetails(data.events)}
          >
            <span className="badge rounded-pill bg-primary">{row.events}</span>
          </div>
        )
      },
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "allowOrder",
      text: "Allow Order",
      sort: true,
      formatter: (cellContent, row) => {
        return (
          <div>
            <Badge
              color={row.allowOrderData === true ? "success" : "danger"}
              style={{ padding: "6px", fontSize: "12px" }}
            >
              {" "}
              {row.allowOrder}
            </Badge>
          </div>
        )
      },
      style: (cell, row) => {
        if (row.isAlter != true) {
          return {
            backgroundColor: "",
          }
        } else {

          return {
            backgroundColor: "#3abd856e",
          }
        }
      },
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "overallStatus",
      text: "Overall Status",
      sort: true,
      style: (cell, row) => {
        if (row.isAlter != true) {
          return {
            backgroundColor: "",
            color: "#e40d8c",
            textTransform: "uppercase",
          }
        } else {

          return {
            backgroundColor: "#3abd856e",
            color: "#e40d8c",
            textTransform: "uppercase",
          }
        }
      },
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "clearanceReport",
      text: "Clearance Report",
      sort: true,
      csvExport: false,
      formatter: (cellContent, row) => {
        return (
          <>
            {row.ecProcessStatus !== "PS2" ? (
              <button
                style={{
                  background: row.colorCode,
                  border: "none",
                  cursor: "pointer",
                  color: "white",
                  padding: "2px 4px",
                  borderRadius: "4px",
                }}
              >
                {row.statusName}
              </button>
            ) : (
              <Button
                className="btn btn-warning"
                onClick={() => {
                  setClearanceModal(true)
                  // setLeadId(row._id)
                }}
                style={{ display: "inline-block", fontSize: "10px" }}
              >
                Move To Clearance
              </Button>
            )}
          </>
        )
      },
      // style: (cell, row) => ({
      //   backgroundColor: row.alter == true ? "#3abd856e" : "",
      // }),
      style: (cell, row) => {
        console.log(row.isAlter, "isAlter")
        if (row.isAlter != true) {
          return {
            backgroundColor: "",
          }
        } else {

          return {
            backgroundColor: "#3abd856e",
          }
        }
      },
      headerStyle: {
        minWidth: "165px",
      },
    },
    {
      dataField: "leadStatus",
      text: "EC Status",
      sort: true,
      formatter: (cellContent, row) => {
        return (
          <Badge color="success" style={{ padding: "6px" }}>
            {" "}
            {row.leadStatus}
          </Badge>
        )
      },
      style: (cell, row) => {
        console.log(row.isAlter, "isAlter")
        if (row.isAlter != true) {
          return {
            backgroundColor: "",
            textTransform: "uppercase"
          }
        } else {

          return {
            backgroundColor: "#3abd856e",
            textTransform: "uppercase"
          }
        }
      },
      headerStyle: {
        minWidth: "138px",
      },
      //  filter: selectFilter({
      //   options: selectOptions
      // })
    },
  ]
  // pagination options
  const options = {
    sizePerPage: 50,
    totalSize: teamSchedule_details.length, // replace later with size(customers),
    custom: true,
    pageStartIndex: 1,
    firstPageText: "First",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
  }

  const expandRow = {
    renderer: (row) => (
      <>
        <Table bordered>
          <thead>
            <tr>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Event No
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Event Name
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Event Date
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Time
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Location
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Venue Name
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Crowd Strength
              </th>
            </tr>
          </thead>
          <tbody>
            {row && row.eventDetails.length > 0 ? (
              row.eventDetails.map((data) => {
                console.log(data, "row list data")

                const dateFormate =
                  !isEmpty(dateSetting) && dateSetting ? dateSetting : ""

                console.log(dateFormate, "dateFormate")
                const eventFromDate = moment(data.eventDate).format(
                  "YYYY-MM-DD"
                )
                console.log(eventFromDate, "eventFrom Date")
                const eventDate = new Date(data.eventDate)
                console.log(eventDate, "eventDate")
                if (
                  new Date(data.eventDate) >= new Date(myTeamData.fromDate) &&
                  new Date(data.eventDate) <= new Date(myTeamData.toDate)
                ) {
                  const rowStyle =
                    data.isAlter == true ? { backgroundColor: "#3abd856e" } : {}
                  console.log(data, "expandRow data")
                  return (
                    <tr key={data._id}>
                      <th scope="data" style={rowStyle}>
                        {data.eventNo}
                      </th>
                      <td style={rowStyle}>{data.eventName}</td>
                      <td style={rowStyle}>
                        {moment(data.eventDate).format(dateFormate)}
                      </td>
                      <th style={rowStyle}>{data.crewAssemblyTime}</th>
                      <td style={rowStyle}>{data.venueLocation}</td>
                      <td style={rowStyle}>{data.venueName}</td>
                      <td style={rowStyle}>{data.crowdStrength}</td>
                    </tr>
                  )
                } else if (
                  isEmpty(myTeamData.fromDate) &&
                  isEmpty(myTeamData.toDate)
                ) {
                  const rowStyle =
                    data.isAlter == true ? { backgroundColor: "#3abd856e" } : {}
                  return (
                    <tr key={data._id}>
                      <th scope="data" style={rowStyle}>
                        {data.eventNo}
                      </th>
                      <td style={rowStyle}>{data.eventName}</td>
                      <td style={rowStyle}>
                        {moment(data.eventDate).format(dateFormate)}
                      </td>
                      <th style={rowStyle}>{data.crewAssemblyTime}</th>
                      <td style={rowStyle}>{data.venueLocation}</td>
                      <td style={rowStyle}>{data.venueName}</td>
                      <td style={rowStyle}>{data.crowdStrength}</td>
                    </tr>
                  )
                } else {
                  const rowStyle =
                    data.isAlter == true ? { backgroundColor: "#3abd856e" } : {}
                  return (
                    <tr key={data._id}>
                      <th scope="data" style={rowStyle}>
                        {data.eventNo}
                      </th>
                      <td style={rowStyle}>{data.eventName}</td>
                      <td style={rowStyle}>
                        {moment(data.eventDate).format(dateFormate)}
                      </td>
                      <th style={rowStyle}>{data.crewAssemblyTime}</th>
                      <td style={rowStyle}>{data.venueLocation}</td>
                      <td style={rowStyle}>{data.venueName}</td>
                      <td style={rowStyle}>{data.crowdStrength}</td>
                    </tr>
                  )
                }
              })
            ) : (
              <tr key={0}>
                <td className="text-align-center" colSpan={7}>
                  No data found
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </>
    ),
    showExpandColumn: true,
    expandByColumnOnly: true,
    onlyOneExpanding: true,
    //expanded:expandrow?true:false
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{title} | Zero Gravity CRM</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title={"Event Coordination"} breadcrumbItem={title} />

          {/*form start */}
          <Row>
            <Col xs={12}>
              <Card>
                <CardBody>
                  <form>
                    <Row>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"} htmlFor={"Company"}>
                            {"Company"}
                          </Label>
                        </div>

                        <Select
                          type="text"
                          name="companies"
                          isMulti
                          value={companies}
                          onChange={(e) => setCompanies(e)}
                          options={
                            recordsMetaData
                              ? recordsMetaData.companyOptions
                              : []
                          }
                          placeholder="Select Company"
                          classNamePrefix="select2-selection"
                          zIndex="2"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"} htmlFor={"Branch"}>
                            {"Branch"}
                          </Label>
                        </div>
                        <Select
                          type="text"
                          name="branches"
                          isMulti
                          value={branches}
                          onChange={(e) => setBranches(e)}
                          options={branchOptions}
                          placeholder="Select Branch"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"}>{"Event"}</Label>
                        </div>
                        <Select
                          type="text"
                          name="events"
                          value={events}
                          // isMulti
                          onChange={(e) => setEvents(e)}
                          options={
                            recordsMetaData ? recordsMetaData.eventOptions : []
                          }
                          placeholder="Select Event"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"}>{"EC Agent"}</Label>
                        </div>
                        <ReactSearchAutocomplete
                          name="salesAgent"
                          items={ecagentOptions}
                          value={salesAgent}
                          type="autoComplete"
                          resultStringKeyName="label"
                          showIcon={false}
                          onSelect={(e) => setSalesAgent(e)}
                          onChange={(e) => setSalesAgent(e.target.value)}
                          placeholder="Enter EC Agent"
                          fuseOptions={fuseOptions} // Search on both fields
                          styling={{
                            height: "34px",
                            border: "1px solid #ced4da",
                            borderRadius: "4px",
                            backgroundColor: "white",
                            boxShadow: "none",
                            hoverBackgroundColor: "#E40D8C",
                            color: "black",
                            fontSize: "12px",
                            fontFamily: "Courier",
                            iconColor: "green",
                            clearIconMargin: "3px 8px 0 0",
                            zIndex: 10,
                          }}
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className="form-label"
                            htmlFor={"Event From Date"}
                          >
                            {"Event From Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          placeholder="Select Date"
                          name="fromDate"
                          value={myTeamData.fromDate}
                          max={myTeamData.toDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>

                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className="form-label"
                            htmlFor={"Event To Date"}
                          >
                            {"Event To Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          placeholder="Select Date"
                          name="toDate"
                          value={myTeamData.toDate}
                          min={myTeamData.fromDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className="form-label"
                            htmlFor={"Event To Date"}
                          >
                            {"Lead No"}
                          </Label>
                        </div>
                        <Input
                          type="text"
                          placeholder="Enter Lead No"
                          name="leadNo"
                          value={myTeamData.leadNo}
                          // min={unAssignedData.fromDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                      <Col lg="3" md="3" sm="3" xs="3" className="mt-5">
                        <div className="d-flex flex-row">
                          {alterList.map((data, index) => {
                            return (
                              <div className="d-flex flex-row" key={index}>
                                <Input
                                  type="checkbox"
                                  name="isAlter"
                                  value={data.value}
                                  checked={isAlter === data.value}
                                  onChange={(e) =>
                                    handleAlterChange(e, data.value)
                                  }
                                  className="font-size-15"
                                />
                                <Label
                                  className="mx-2"
                                  style={{ marginTop: "2px", fontSize: "12px" }}
                                >
                                  {data.label}
                                </Label>
                              </div>
                            )
                          })}
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="12" md="12" sm="12" xs="12" className="mt-3">
                        <div
                          className="filter-buttons"
                          style={{ float: "right" }}
                        >
                          <Button
                            type="button"
                            onClick={() => resetForm()}
                            className="btn btn-danger btn-label simple-form-Reset-btn"
                          >
                            <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                            Reset
                          </Button>
                          <Button
                            type="button"
                            onClick={() => clientFilter()}
                            className="btn btn-success btn-label simple-form-applyfilter-btn mx-2"
                          >
                            <i className="bx bx-filter-alt label-icon"></i>
                            {btnLoader && btnLoader ? (
                              <ButtonSpinner />
                            ) : (
                              "Apply Filter"
                            )}{" "}
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col md="12" lg="12" xl="12">
              <Card>
                <CardBody>
                  <PaginationProvider
                    pagination={paginationFactory(options)}
                    keyField="_id"
                    columns={columns}
                  >
                    {({ paginationProps, paginationTableProps }) => (
                      <ToolkitProvider
                        keyField="_id"
                        data={myClientDataTable}
                        columns={columns}
                        search
                        exportCSV

                      >
                        {(props) => (
                          <div>
                            <Col md="12" xl="12" lg="12" sm="12" xs="12">
                              <Row className="d-flex flex-row">
                                <Col className="mb-3" md="4">
                                  <div className="d-flex flex-row ">
                                    <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                                      <div
                                        className="position-relative mt-7"
                                        style={searchBarStyle || null}
                                      >
                                        <SearchBar {...props.searchProps} />
                                        <i className="bx bx-search-alt search-icon" />
                                      </div>
                                    </div>
                                  </div>{" "}
                                </Col>
                                <Col>
                                  <div>
                                    <ExportCSVButton
                                      className="border float-right mx-10"
                                      style={{
                                        float: "right",
                                        backgroundColor: "#e40d8c",
                                        color: "#ffffff",
                                      }}
                                      {...props.csvProps}
                                    >
                                      Download{" "}
                                    </ExportCSVButton>{" "}
                                    <div
                                      style={{
                                        float: "right",
                                        marginRight: "20px",
                                        padding: "10px",
                                      }}
                                    >
                                      <div className="d-flex flex-row">

                                        <div className="quote-altered-lead"></div>
                                        <h6 className="alter-font">
                                          Quote Altered Lead
                                        </h6>
                                      </div>
                                      <div>
                                      <h6 className="cp-font">
                                        CP - Client Profile
                                      </h6>
                                    </div>
                                    </div>
                                   
                                  </div>
                                </Col>

                                <Col>
                                  <BootstrapTable
                                    {...props.baseProps}
                                    responsive
                                    // striped={true}
                                    bordered={true}
                                    keyField="_id"
                                    columns={columns}
                                    //  filter={ filterFactory() }
                                    expandRow={expandRow}
                                    //  rowStyle={rowStyle}
                                    {...paginationTableProps}
                                  />
                                </Col>
                              </Row>
                              <Row
                                style={{ marginTop: "5px" }}
                                className="align-items-md-center mt-30"
                              >
                                <Col className="inner-custom-pagination d-flex">
                                  <div className="d-inline d-flex flex-row">
                                    <SizePerPageDropdownStandalone
                                      {...paginationProps}
                                    />
                                    <div
                                      style={{
                                        fontSize: "14px",
                                        marginTop: "8px",
                                        marginLeft: "4px",
                                      }}
                                    >
                                      <PaginationTotalStandalone
                                        {...paginationProps}
                                      />
                                    </div>
                                  </div>
                                  <div
                                    className="text-md-right ms-auto"
                                    style={{ zIndex: 0 }}
                                  >
                                    <PaginationListStandalone
                                      {...paginationProps}
                                    />
                                  </div>
                                </Col>
                              </Row>
                            </Col>
                          </div>
                        )}
                      </ToolkitProvider>
                    )}
                  </PaginationProvider>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {clearanceModal && (
            <Modal
              show={clearanceModal}
              size="md"
              style={{ backgroundColor: "#504e4ec9", opacity: 0.98 }}
            >
              <Modal.Header
                style={{
                  backgroundColor: "#E40D8C",
                  color: "white",
                  minHeight: "65px",
                  fontSize: "16px",
                  fontWeight: "600",
                }}
              >
                <div className="d-flex flex-row">
                  <span>Clearance Report</span>
                </div>
              </Modal.Header>
              <Modal.Body>Do You Want To Clearance The Report?</Modal.Body>

              <Modal.Footer>
                <div>
                  <Button
                    type="submit"
                    onClick={() => {
                      setClearanceModal(false)
                    }}
                    // style={{ fontSize: "10px", marginLeft: "20px" }}
                    className="btn btn-danger buttons"
                  >
                    {" "}
                    Cancel
                  </Button>
                  <Button
                    type="submit"
                    onClick={() => {
                      setClearanceModal(false)
                    }}
                    style={{ marginLeft: "20px" }}
                    className="btn btn-success buttons"
                  >
                    {" "}
                    Confirm
                  </Button>
                </div>
              </Modal.Footer>
            </Modal>
          )}
        </Container>
      </div>
    </React.Fragment>
  )
}

MyTeamSchedule.propTypes = {
  dispatch: PropTypes.func,
  searchProps: PropTypes.func,
  baseProps: PropTypes.any,
  searchBarStyle: PropTypes.any,
  csvProps: PropTypes.any,
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}
const mapStateToProps = () => ({
  //mapstate to props
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MyTeamSchedule)
)
